module.exports = __webpack_public_path__ + "img/dsci0087.194131f8.jpg";